import React, { useState, useEffect } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
// import { users_get } from '../../../../../services/configuration/users';
import { users_get } from '../../../../../services/configuration/users';
export interface UserOption {
    id: number;
    fullusername: string;
    email: string;
}

interface Props {
    value: UserOption | null;
    onChange: (user: UserOption | null) => void;
    onBlur: () => void;
}

const UserAutocompleteInline: React.FC<Props> = ({ value, onChange, onBlur }) => {
    const [inputValue, setInputValue] = useState('');
    const [allUsers, setAllUsers] = useState<UserOption[]>([]);
    const [filteredOptions, setFilteredOptions] = useState<UserOption[]>([]);
    const [loading, setLoading] = useState(false);
    const [fetched, setFetched] = useState(false); // 👈 para evitar múltiples peticiones

    // 🔁 Solo una vez: obtener todos los usuarios
    useEffect(() => {
        const fetchUsers = async () => {
            setLoading(true);
            try {
                const res = await users_get();
                setAllUsers(res.data);
                setFetched(true);
            } catch (err) {
                console.error('Error al obtener usuarios', err);
            } finally {
                setLoading(false);
            }
        };

        if (!fetched) fetchUsers();
    }, [fetched]);

    // 🔍 Filtro local basado en lo que escribe el usuario
    useEffect(() => {
        if (inputValue.length < 2) {
            setFilteredOptions([]);
            return;
        }

        const filtered = allUsers.filter((user) =>
            `${user.fullusername} ${user.email}`.toLowerCase().includes(inputValue.toLowerCase())
        );
        setFilteredOptions(filtered);
    }, [inputValue, allUsers]);

    return (
        <Autocomplete
            value={value}
            onChange={(event, newValue) => onChange(newValue)}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
            onBlur={onBlur}
            options={filteredOptions}
            getOptionLabel={(option) => `${option.fullusername} (${option.email})`}
            loading={loading}
            fullWidth
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    autoFocus
                    placeholder="Buscar usuario..."
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading && <CircularProgress color="inherit" size={20} />}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};

export default UserAutocompleteInline;
